import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import EmptyState from '@/components/feature/EmptyState';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { allStars, getArticlesByStar } from '@/utils/articles';

export default function StarPage() {
  const [keyword, setKeyword] = useState('');

  useDocumentMeta(
    '明星专题 - 91黑料娱乐黑料爆料平台',
    '91黑料明星专题，汇集当红明星的个人档案与相关爆料合集，方便粉丝系统浏览明星内幕与动态。',
  );

  const list = useMemo(() => {
    const kw = keyword.trim().toLowerCase();
    const sorted = allStars.slice().sort((a, b) => b.heat - a.heat);
    if (!kw) return sorted;
    return sorted.filter(
      (s) => s.name.toLowerCase().includes(kw) || s.title.toLowerCase().includes(kw),
    );
  }, [keyword]);

  return (
    <div className="max-w-content mx-auto px-4 md:px-6 py-6 md:py-8">
      <Breadcrumb items={[{ label: '明星专题' }]} />

      <header className="mt-5 md:mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-foreground-950 flex items-center gap-3">
            <span className="w-10 h-10 rounded-lg bg-secondary-600 text-background-50 flex items-center justify-center">
              <i className="ri-user-star-line text-xl"></i>
            </span>
            明星专题
          </h1>
          <p className="text-sm text-foreground-600 mt-3 max-w-3xl">
            以明星为线索，系统整理每一位艺人的个人档案与相关爆料合集。点击卡片即可进入明星专题详情，查看其全部关联内容。
          </p>
        </div>
        <div className="relative w-full md:w-72 shrink-0">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索明星名称"
            className="w-full pl-9 pr-3 py-2.5 text-sm rounded-md bg-background-50 border border-background-300 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
          />
        </div>
      </header>

      {list.length === 0 ? (
        <EmptyState
          icon="ri-user-search-line"
          title="未找到匹配的明星"
          description="换个关键词试试，或浏览全部明星专题。"
          onAction={() => setKeyword('')}
        />
      ) : (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {list.map((star) => {
            const related = getArticlesByStar(star.id).length;
            return (
              <Link
                key={star.id}
                to={`/star/${star.id}`}
                className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
              >
                <div className="relative w-full aspect-[4/3] bg-background-100 overflow-hidden">
                  <img
                    src={star.avatar}
                    alt={star.name}
                    title={`${star.name}-91黑料明星专题`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="text-lg font-black text-background-50">{star.name}</h3>
                    <p className="text-xs text-background-200">{star.title}</p>
                  </div>
                  <span className="absolute top-3 right-3 px-2 py-1 rounded-md text-[11px] font-medium bg-accent-500 text-background-50 flex items-center gap-0.5">
                    <i className="ri-fire-line"></i> 热度 {star.heat}
                  </span>
                </div>
                <div className="p-4">
                  <p className="text-sm text-foreground-600 line-clamp-2 h-[42px]">{star.bio}</p>
                  <div className="flex flex-wrap gap-2 mt-3">
                    {star.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-group-line"></i> {star.followers} 关注
                    </span>
                    <span className="flex items-center gap-1 text-primary-600 font-medium">
                      {related} 条专题内容 <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}